/* rwer.vue */
<template xlang="wxml">
  <div :class="{ 'table-content': true, 'table-content-active': this.open }">
    <h3>我的待办</h3>
    <ul class="tabList-wrap">
      <li class="tab-list-item" :class="{ 'tabs-current': activeName === item.value }" v-for="item in tabList"
        :key="item.value" @click="handClick(item)">
        <img src="@/assets/images/common/gong_icon_lightblue.png" />
        {{ item.label }}
        <div>{{ numArry[item.key] ? numArry[item.key] : '0' }}</div>
      </li>
    </ul>
    <div class="table-box">
      <a-table :columns="columns1" :data-source="workList" :loading="tableLoading" :pagination="pagination" :rowKey="(record, index) => {
        return index;
      }
        " @change="handleTableChange" :locale="{ emptyText:renderEmpty }">
        <template slot="operate" slot-scope="text, record">
          <div class="operate" v-if="activeName !== 3">
            <div>
              <span v-if="record.cureentNodeCode === 'NODE0035' && [4, 6].includes(record.progressBar)"
                @click.stop="uploadAuthorization(true, record)" class="btF upload-btn">
                <!--平台审核-签署授权书和驳回: cureentNodeCode === 'NODE0035' && [4,6].includes(record.progressBar) -->
                上传授权书
              </span>
              <!-- NODE6410-待提交资料 NODE6402-待选择答复方案 NODE6408-待支付 NODE6416-待签署授权书 -->
              <span v-else-if="['NODE6410', 'NODE6402', 'NODE6408', 'NODE6416'].includes(record.cureentNodeCode)"
                @click.stop="$router.push('/reviewOpinions')" class="btF upload-btn">
               去处理
              </span>

              <span v-else-if="record.serviceProgressStr !== '答复审查意见'" @click.stop="toJump(record)"
                class="btF upload-btn">
                {{ record.serviceProgressStr }}
              </span>
            </div>
          </div>
        </template>
      </a-table>
    </div>
    <UploadAuthorizationLetter :currRow="currRow" @uploadAuthorization="uploadAuthorization" @getList="getWorkTodoList"
      @getViewWorkNum="getViewWorkNum" v-if="uploadAuthorizationLetterVisiale" />
    <!-- 多条核名报告 -->
    <NameVerificationReportPop ref="nvrPop" :currRow="currRow" :workRelWorkOrderList="workRelWorkOrderList" />
    <IframeModal ref="IframeModal" @submit="
      getWorkTodoList();
    getViewWorkNum();
    " />
  </div>
</template>
<script>
import { viewBacklogList, viewWorkNum } from '@/api/work/index';
import IframeModal from '@comp/module/iipto/common/IframeModal.vue';
import NameVerificationReportPop from '@/components/common/NameVerificationReportPop.vue';
import { getAuditModeStatus } from '@/api/trademarkRegister/myBread';
export default {
  props: ['open'],
  components: {
    IframeModal,
    NameVerificationReportPop
  },
  data: () => ({
    activeName: '1',
    tabList: [
      { label: '全部', value: '1', key: 'allNum' },
      { label: '待提交资料', value: '2', key: 'dataSubmittedNum' },
      { label: '答复审查意见', value: '3', key: 'reviewNum' },
      { label: '待提交使用证据', value: '5', key: 'submitEvidenceNum' },
      { label: '待签署授权书', value: '4', key: 'uploadAuthNum' },
      { label: '待确认核名报告', value: '6', key: 'waitConfirmCheckNum' },
    ],
    numArry: {},
    workForm: {
      size: 10,
      current: 1,
      type: '1',
    },
    workTotal: 0,
    tableLoading: false,
    pagination: {},
    workList: [],
    columns1: [
      {
        title: '事项',
        dataIndex: 'matter',
        key: 'matter',
        ellipsis: true,
      },
      {
        title: '服务商品',
        dataIndex: 'serviceName',
        key: 'serviceName',
        ellipsis: true,
      },
      {
        title: '国家',
        dataIndex: 'countryNameZh',
        key: 'countryNameZh',
        ellipsis: true,
      },

      {
        title: '服务号',
        dataIndex: 'serviceNo',
        key: 'serviceNo',
        width: 200,
      },
      {
        title: '操作',
        key: 'operate',
        scopedSlots: { customRender: 'operate' },
        width: 250,
      },
    ],
    uploadAuthorizationLetterVisiale: false,
    currRow: '',
    workRelWorkOrderList: [],
  }),
  watch: {
    open() {
      if (this.open) {
        this.setOpen();
      }
    },
  },
  mounted() {
    this.getWorkTodoList();
    this.getViewWorkNum();
  },
  methods: {
    renderEmpty(){
      return <div style="padding:20px"><img src="https://file.cjtglobal.com/pro/20240711/9066e3b182cf4f71b55b8e0562489c20/default-img.png"/><div style="margin-top:20px" >暂无数据</div></div> 
    },
    setOpen() {
      this.timer = setTimeout(() => {
        this.$emit('close');
      }, 3000);
    },
    pageSizeChangeHandler(pageSize) {
      this.workForm.size = pageSize;
      this.getWorkTodoList();
    },
    changePageHandler(page) {
      this.workForm.current = page;
      this.getWorkTodoList();
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.workForm.current = pagination.current;
      this.getWorkTodoList();
    },
    //获取待办工单的列表
    getWorkTodoList() {
      this.tableLoading = true;
      let data = this.getParmes(this.workForm);
      viewBacklogList(data).then((res) => {
        if (res.code === 0) {
          this.workList = res.data.records;
          this.workTotal = Number(res.data.total);
          this.tableLoading = false;
          const pagination = { ...this.pagination };
          pagination.total = Number(res.data.total);
          this.pagination = pagination;
        }
      });
    },
    getViewWorkNum() {
      viewWorkNum({}).then((res) => {
        if (res.code === 0) {
          this.numArry = { ...res.data };
        }
      });
    },
    getParmes(json) {
      for (name in json) {
        if (json[name] == '' || json[name] == undefined || json[name] == []) {
          delete json[name];
        }
      }
      return json;
    },
    handClick(item) {

      this.activeName = item.value
      this.workForm.type = this.activeName;
      this.workForm.current = 1;
      this.pagination.current = 1;
      this.getWorkTodoList();
    },
    goReportPage(workOrder) {
      let reportVOList = workOrder.trademarkSearchRecordReportVOList;
      reportVOList = reportVOList[reportVOList.length - 1];
      let routeUrl = this.$router.resolve({
        path: '/trademarkNameReviewReport',
        query: {
          recordId: workOrder.id,
          linkId: reportVOList.id,
          workId: this.currRow.workOrderId,
          servicesId: this.currRow.servicesId,
        },
      });
      window.open(routeUrl.href, '_blank');
    },
    toJump(row) {
      if (row.matter === '确认核名报告') {
        this.currRow = row;
        this.workRelWorkOrderList = row.trademarkSearchRecordWorkRelWorkOrderList.filter((ele) =>
          ['WAIT_CONFIRM', 'RECHECK_WAIT_CONFIRM', 'AUDIT_WAIT_CONFIRM'].includes(ele.recordStatus)
        );
        if (this.workRelWorkOrderList.length > 1) {
          this.$refs.nvrPop.nameVerificationReportVisible = true;
        } else {
          this.goReportPage(this.workRelWorkOrderList[0]);
        }
      }
      let code = row.cureentNodeCode;
      let subJson = {
        id: row.servicesId,
        progressBar: row.progressBar,
        nodeCode: row.cureentNodeCode,
        code: row.countryCode,
        form: 'work',
      };
      if (code == 'NODE0033') {
        getAuditModeStatus({
          workId: row.workOrderId,
          functionCode: row.productFunctionCode,
        }).then((res) => {
          if (res.code == 0 && res.data) {
            this.$Message.warning('此工单正在审核中');
          } else {
            this.$refs.IframeModal.url = '/workorder/submitregistinfo';
            this.$refs.IframeModal.params = {
              id: row.servicesId,
            };
            this.$refs.IframeModal.showModal = true;
          }
        });
        // this.$router.push({
        //   path: '/infoDetail',
        //   query: subJson,
        // });
      } else if (code == 'NODE0037' || code == 'NODE0036') {
        this.$router.push({
          path: '/myBrand',
          query: { isShowDetail: 2, servicesId: row.servicesId, cureentNodeCode: row.cureentNodeCode, form: 'work' },
        });
      } else if (['NODE0139', 'NODE0140'].includes(code)) {
        getAuditModeStatus({
          workId: row.workOrderId,
          functionCode: row.productFunctionCode,
        }).then((res) => {
          if (res.code == 0 && res.data) {
            this.$Message.warning('此工单正在审核中');
          } else {
            this.$refs.IframeModal.url = '/workorder/submitevidence';
            this.$refs.IframeModal.params = {
              id: row.servicesId,
            };
            this.$refs.IframeModal.showModal = true;
          }
        });

        // this.$router.push({
        //   path: '/fillEvidence',
        //   query: {
        //     id: row.servicesId,
        //     progressBar: row.progressBar,
        //     nodeCode: row.cureentNodeCode,
        //     code: row.countryCode,
        //     countryNameZh: row.countryNameZh,
        //     from: 'work',
        //   },
        // });
      }
    },
    //显示上传授权书弹窗
    uploadAuthorization(flag, row) {
      this.currRow = row;
      this.uploadAuthorizationLetterVisiale = flag;
    },
  },
};
</script>

<style lang="less" scoped>
.table-content {
  background: #ffffff;
  padding: 20px 10px;

  h3 {
    font-size: 18px;
    margin-bottom: 16px;
  }

  .order-heaer {
    border-bottom: 1px #e9e9e9 solid;
    margin-bottom: 20px;

    span {
      font-size: 16px;
      font-weight: 500;
      line-height: 34px;
      margin-right: 20px;
    }
  }



  .pageSetion {
    text-align: left;
    margin-top: 36px;
    padding-bottom: 36px;
    margin-left: 24px;
  }

  .operate {
    cursor: pointer;
    font-weight: 500;
    padding-top: 2px;

    img {
      width: 11px;
      margin-bottom: 2px;
    }

    .btF {
      min-width: 124px;
    }

    .btF.flex-center {
      // display: inline-block;
      min-width: 124px;
      // background: #ffffff;
      color: #f79728;
      border-color: #f79728;

      img {
        width: 18px;
        // height: 18px;
      }
    }

    .red-button {
      color: #ed3e3e;
      border-color: #ed3e3e;
    }

    .upload-btn {
      // margin-right: 10px;
      // border-color: #16ade9;
      color: @brandColor;

      // background-color: #fff;
      img {
        width: 18px;
        // height: 18px;
      }
    }

    .btR {
      min-width: 124px;
      background: #ed3e3e;
    }
  }

  // /deep/.ant-table-content {
  //   height: 563px !important;
  // }
  /deep/.ant-tabs-bar {
    border-bottom: none;
  }

  /deep/.ant-tabs-ink-bar {
    opacity: 0;
  }

  /deep/.ant-tabs-tab {
    background: #F3F9FF;
    border: 1px solid #3190FF;
    height: 100px;
    color: #3190FF;
  }

  /deep/.ant-tabs-tab:hover,
  /deep/.ant-tabs-tab-active {
    background: #D9EBFF;
    border-bottom: 5px solid #3190FF;
  }

  /deep/.ant-table-thead>tr>th {
    background: @bgColor2;
  }
}

.table-content-active {
  box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.05), 0px -8px 8px 0px rgba(0, 0, 0, 0.05),
    -8px 0px 8px 0px rgba(0, 0, 0, 0.05), 8px 0px 8px 0px rgba(0, 0, 0, 0.05);
}


.tabList-wrap {
  display: flex;
  justify-content: space-between;
}

.tab-list-item {
  text-align: center;
  font-size: 16px;
  width: 15.5%;
  border: 1px solid #3190FF;
  height: 86px;
  color: #3190FF;
  padding: 14px;
  position: relative;
  cursor: pointer;
  background-color: #F3F9FF;

  img {
    position: absolute;
    top: 2px;
    left: 2px;
  }

  &:hover {
    background: #D9EBFF;
    border-bottom: 5px solid #3190FF;
  }

  >div {
    font-size: 30px;
    margin-top: 5px;
  }
}

.tabs-current {
  background: #D9EBFF;
  border-bottom: 5px solid #3190FF;
}
</style>



// WEBPACK FOOTER //
// src/views/work/components/workOrder.vue